export default "__VITE_ASSET__D6Yt3Q2J__"